import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Layouts} from '../app.component';
import {DataCatalogueComponent} from './data-catalogue.component';
import {ObjectViewComponent} from "./object-view/object-view.component";

const routes: Routes = [
    {
        path: 'data-catalogue',
        component: DataCatalogueComponent,
        data: { layout: Layouts.SecureLayout }
    },
    {
        path: 'data-catalogue/:catId/object/:objectId',
        component: ObjectViewComponent,
        data: { layout: Layouts.SecureLayout }
    }
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DataCatalogueRoutingModule { }